(() => {
  const dialog = document.querySelector('[data-look-gallery-dialog]');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = 'true';
  const title = dialog.querySelector('[data-gallery-title]');
  const stage = dialog.querySelector('[data-gallery-stage]');
  const thumbs = dialog.querySelector('[data-gallery-thumbs]');
  const actions = dialog.querySelector('[data-gallery-actions]');
  const mobileActions = dialog.querySelector('[data-gallery-mobile-actions]');
  const questions = dialog.querySelector('[data-gallery-questions]');
  const questionList = dialog.querySelector('[data-gallery-question-list]');
  const count = dialog.querySelector('[data-gallery-count]');
  const fallback = dialog.querySelector('[data-gallery-fallback]');
  const productBody = dialog.querySelector('[data-gallery-product]');
  const pending = dialog.querySelector('[data-gallery-pending]');
  const feedback = dialog.querySelector('[data-gallery-feedback]');
  const shareControls = dialog.querySelector('.look-gallery__share');
  let opener = null, slides = [], index = 0, request = 0, controller = null, currentCard = null;
  function dispose() {
    fallback.querySelector('.look-gallery__views').append(shareControls);
    productBody.querySelectorAll('[data-product-section]').forEach(root => {
      if (root.__dstProduct) root.__dstProduct.destroy();
    });
    productBody.replaceChildren();
  }
  function show(next) {
    if (!slides.length) return;
    index = (next + slides.length) % slides.length;
    stage.src = slides[index].dataset.gallerySrc;
    stage.alt = slides[index].dataset.galleryAlt || title.textContent;
    count.textContent = `${index + 1} / ${slides.length}`;
    thumbs.querySelectorAll('button').forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    dialog.querySelectorAll('[data-gallery-step]').forEach(button => { button.hidden = slides.length < 2; });
    dialog.querySelectorAll('[data-gallery-thumb-step]').forEach(button => { button.hidden = slides.length <= 3; });
    const activeThumb = thumbs.children[index];
    if (activeThumb && thumbs.clientWidth) {
      const pageStart = thumbs.children[Math.floor(index / 3) * 3];
      thumbs.scrollTo({left:pageStart.offsetLeft - thumbs.firstElementChild.offsetLeft,behavior:'smooth'});
    }
  }
  function purchaseAction(card) {
    return card.querySelector('[data-gallery-purchase-source]')?.content.querySelector('[data-gallery-purchase]') || card.querySelector('[data-gallery-purchase]');
  }
  function copyAction(card) {
    actions.replaceChildren();
    mobileActions.replaceChildren();
    mobileActions.hidden = card.dataset.galleryExternal !== 'true';
    const sourceAction = purchaseAction(card);
    if (!sourceAction) return;
    const action = sourceAction.cloneNode(true);
    ['id','aria-haspopup','data-quick-shop','data-url'].forEach(attr => action.removeAttribute(attr));
    actions.append(action);
    if (!mobileActions.hidden) mobileActions.append(action.cloneNode(true));
  }
  async function loadProduct(card) {
    const productUrl = card.dataset.galleryProductUrl;
    if (!productUrl) return;
    const mine = ++request;
    if (controller) controller.abort();
    controller = new AbortController();
    pending.hidden = false;
    pending.textContent = dialog.dataset.loadingLabel;
    actions.replaceChildren();
    try {
      const url = new URL(productUrl, location.origin);
      if (url.origin !== location.origin) throw new Error('origin');
      const response = await fetch(url, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('response');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = doc.querySelector('[data-product-section]');
      if (!section) throw new Error('product');
      if (mine !== request || !dialog.open) return;
      section.querySelectorAll('.breadcrumbs,[data-sticky-buy],[data-lightbox],script:not([type="application/json"])').forEach(node => node.remove());
      section.querySelectorAll('[data-lightbox-open]').forEach(node => {node.removeAttribute('data-lightbox-open'); node.querySelector('.product__zoom-icon')?.remove();});
      if (!window.DST?.namespaceProduct || !window.DST?.ProductUI) throw new Error('controller');
      DST.namespaceProduct(section, 'Look-' + mine + '-');
      section.dataset.lookProductWindow = 'true';
      const productLayout = section.querySelector('.product');
      const purchase = section.querySelector('.product__buy');
      if (productLayout && purchase) {
        const price = section.querySelector('.product__price');
        if (price) purchase.prepend(price);
        const heading = document.createElement('h3');
        heading.textContent = dialog.dataset.purchaseLabel;
        purchase.prepend(heading);
        const info = section.querySelector('.product__info');
        if (purchase.classList.contains('product__buy--aff') && info) {
          const source = purchaseAction(card);
          const existing = purchase.querySelector('.product__aff-btn');
          if (source && existing) existing.replaceWith(source.cloneNode(true));
          const sellerNote = purchase.querySelector('.product__aff-sold');
          if (sellerNote) sellerNote.textContent = dialog.dataset.retailerCheckoutLabel;
          info.prepend(purchase);
        } else {
          productLayout.append(purchase);
        }
        const accordions = Array.from(section.querySelectorAll('.product__info details.accordion'));
        if (accordions.length) {
          const group = document.createElement('section');
          group.className = 'look-gallery__questions';
          const label = document.createElement('h3');
          label.textContent = questions.querySelector('h3').textContent;
          const list = document.createElement('div');
          list.className = 'look-gallery__faq';
          accordions.forEach(node => { node.open = false; list.append(node); });
          group.append(label, list); productLayout.append(group);
        }
      }
      dispose();
      productBody.append(document.importNode(section, true));
      const productThumbs = productBody.querySelector('.product__thumbs');
      const productStage = productBody.querySelector('.product__stage');
      if (productThumbs) {
        const strip=document.createElement('div');strip.className='look-gallery__product-thumb-strip';strip.dataset.thumbPage='0';
        productThumbs.before(strip);
        const nav=dialog.querySelector('.look-gallery__thumb-nav').cloneNode(true);
        const nativeThumbs=[...productThumbs.querySelectorAll('button')];
        const label=nav.querySelector('[data-gallery-count]');label.removeAttribute('data-gallery-count');label.textContent='1 / '+nativeThumbs.length;
        nav.querySelectorAll('[data-gallery-thumb-step]').forEach(button=>{button.dataset.productThumbStep=button.dataset.galleryThumbStep;button.removeAttribute('data-gallery-thumb-step');button.hidden=nativeThumbs.length<=3;});
        strip.append(nav,productThumbs,shareControls);
      } else if (productStage) productStage.after(shareControls);
      fallback.hidden = true;
      productBody.hidden = false;
      document.dispatchEvent(new CustomEvent('dst:product-form-mounted', {detail:{root:productBody}}));
      if (window.Shopify?.PaymentButton?.init) Shopify.PaymentButton.init();
    } catch (error) {
      if (error.name === 'AbortError' || mine !== request || !dialog.open) return;
      pending.textContent = dialog.dataset.errorLabel;
      copyAction(card);
      const retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'look-piece__btn'; retry.dataset.galleryRetry = '';
      retry.textContent = dialog.dataset.retryLabel;
      actions.prepend(retry);
    }
  }
  const related = dialog.querySelector('[data-gallery-related]');
  const relatedGrid = dialog.querySelector('[data-related-grid]');
  const relatedOffsets = new WeakMap();
  let relatedCards = [], relatedIndex = 0;
  function drawRelated() {
    relatedGrid.replaceChildren();
    const count = relatedCards.length;
    for (let i = 0; i < count; i++) {
      const card = relatedCards[i];
      const tile = document.createElement('div');
      const button = document.createElement('button'); button.type='button'; button.dataset.relatedKey=card.dataset.shareKey;
      const image=card.querySelector('.look-piece__media img').cloneNode(true);
      image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.loading='lazy';
      const name=document.createElement('span');name.textContent=card.dataset.galleryProductTitle || card.querySelector('.look-piece__name').textContent.trim();
      button.append(image,name);tile.append(button);
      const purchase=purchaseAction(card);
      if(purchase) {
        const action=purchase.cloneNode(true);['id','data-quick-shop','data-url','aria-haspopup'].forEach(attr=>action.removeAttribute(attr));action.classList.add('look-gallery__related-buy');tile.append(action);
      }
      relatedGrid.append(tile);
    }
    for(let i=relatedCards.length;i<3;i++) {
      const tile=document.createElement('div');tile.className='look-gallery__related-placeholder';
      const image=document.createElement('div');image.className='look-gallery__related-placeholder-image';image.setAttribute('aria-hidden','true');
      const name=document.createElement('p');name.textContent=dialog.dataset.upcomingTitle;
      const status=document.createElement('span');status.className='look-piece__btn look-piece__btn--soon look-gallery__related-buy';status.setAttribute('aria-disabled','true');status.textContent=dialog.dataset.comingSoonLabel;
      tile.append(image,name,status);relatedGrid.append(tile);
    }
    dialog.querySelectorAll('[data-related-step]').forEach(button=>button.hidden=true);
    relatedGrid.scrollLeft=0;
  }
  function populateRelated(card) {
    if (card.dataset.galleryProductUrl) productBody.after(related); else questions.before(related);
    const campaign = card.closest('dst-shop-look,.look-page');
    const category = card.dataset.recommendationCategory;
    const seen = new Set([card.dataset.shareKey]);
    const candidates = campaign ? [...campaign.querySelectorAll('[data-look-gallery-card]')].filter(candidate => {
      const key=candidate.dataset.shareKey;
      if(candidate.dataset.recommendable!=='true' || candidate.dataset.productReady!=='true' || seen.has(key)) return false;
      seen.add(key);return true;
    }) : [];
    relatedCards = candidates.filter(candidate=>category && candidate.dataset.recommendationCategory===category).concat(candidates.filter(candidate=>!category || candidate.dataset.recommendationCategory!==category));
    related.hidden=!campaign;
    related.querySelector('[data-related-title]').textContent=dialog.dataset.relatedLabel;
    relatedIndex=(relatedOffsets.get(card)||0)%Math.max(1,relatedCards.length);
    relatedOffsets.set(card,relatedIndex+3);drawRelated();
  }
  function open(card, trigger) {
    dialog.dataset.shareKey = card.dataset.shareKey;
    dialog.querySelector('[data-product-share-status]').textContent = '';
    dialog.querySelector('[data-share-fallback]').hidden = true;
    const content = card.querySelector('[data-look-gallery-content]');
    if (!content) return;
    request++;
    if (controller) controller.abort();
    dispose();
    fallback.hidden = false; productBody.hidden = true; feedback.hidden = true;
    pending.hidden = false;
    pending.textContent = pending.dataset.defaultText || (pending.dataset.defaultText = pending.textContent);
    const fragment = content.content.cloneNode(true);
    const summary = dialog.querySelector('[data-gallery-summary]');
    const description = fragment.querySelector('[data-gallery-description]');
    dialog.dataset.productStyle = description?.dataset.productStyle || '';
    questionList.replaceChildren();
    const faq = description?.querySelector('[data-gallery-faq]');
    const source = description?.querySelector('[data-gallery-source]');
    if (faq) questionList.append(faq);
    if (source) questionList.append(source);
    questions.hidden = !faq;
    summary.replaceChildren(...(description ? Array.from(description.childNodes) : []));
    if (description?.dataset.galleryPending) pending.textContent = description.dataset.galleryPending;
    const unavailable = card.dataset.productReady !== 'true';
    dialog.dataset.unavailable = String(unavailable);
    if (unavailable) {
      const heading=document.createElement('h3');heading.textContent=dialog.dataset.unavailableTitle;
      const message=document.createElement('p');message.textContent=dialog.dataset.unavailableText;
      summary.replaceChildren(heading,message);pending.hidden=true;
    }
    summary.hidden = !description && !unavailable;
    const seen = new Set();
    slides = Array.from(fragment.querySelectorAll('[data-gallery-src]')).filter(slide => {
      const url = new URL(slide.dataset.gallerySrc, location.origin);
      url.searchParams.delete('width');
      const key = url.toString();
      if (seen.has(key)) return false;
      seen.add(key); return true;
    });
    if (!slides.length && !unavailable) return;
    title.textContent = card.dataset.galleryProductTitle || card.querySelector('.look-piece__name').textContent.trim();
    thumbs.replaceChildren(...slides);
    copyAction(card);
    const note = fragment.querySelector('[data-gallery-note]');
    if (note) {
      actions.append(note); pending.hidden = true;
      const disclosure = fragment.querySelector('[data-gallery-disclosure]');
      if (disclosure) actions.append(disclosure);
      const label = document.createElement('small');
      label.textContent = dialog.dataset.affiliateLabel;
      mobileActions.append(label);
    }
    if (!dialog.open) opener = trigger instanceof HTMLElement ? trigger : card;
    populateRelated(card);
    currentCard = card;
    show(0);
    if (!dialog.open && window.DST?.lockScroll) DST.lockScroll(true);
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelector('[data-gallery-close]').focus({preventScroll:true});
    loadProduct(card);
    dialog.dispatchEvent(new CustomEvent('dst:gallery-opened', {detail:{card}}));
  }
  function openSharedProduct() {
    const key = new URLSearchParams(location.hash.slice(1)).get('product');
    if (!key) return;
    const card = [...document.querySelectorAll('[data-look-gallery-card]')].find(card => card.dataset.shareKey === key);
    if (card && (!dialog.open || currentCard !== card)) open(card, card);
  }
  window.addEventListener('hashchange', openSharedProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openSharedProduct, {once:true}); else openSharedProduct();
  function close() {if (dialog.open) dialog.close();}
  document.addEventListener('click', event => {
    const card = event.target.closest('[data-look-gallery-card]');
    if (!card || event.target.closest('[data-gallery-direct],[data-wishlist-toggle],.look-piece__video,[data-open-dialog]')) return;
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation();
    open(card, event.target.closest('button,a') || card);
  }, true);
  document.addEventListener('keydown', event => {
    const card = event.target.closest('[data-look-gallery-card]');
    if (card && event.target === card && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); open(card, card);
    }
  });
  dialog.addEventListener('click', event => {
    const relatedTarget=event.target.closest('[data-related-key]');
    if(relatedTarget) {const card=relatedCards.find(card=>card.dataset.shareKey===relatedTarget.dataset.relatedKey);if(card) open(card,relatedTarget);return;}
    const relatedStep=event.target.closest('[data-related-step]');
    if(relatedStep && relatedCards.length) {relatedIndex=(relatedIndex+Number(relatedStep.dataset.relatedStep)*3+relatedCards.length)%relatedCards.length;drawRelated();return;}
    if (event.target.closest('[data-gallery-close]')) {close(); return;}
    if (event.target.closest('[data-gallery-retry]')) {loadProduct(currentCard); return;}
    const thumb = event.target.closest('[data-gallery-src]');
    if (thumb) {show(slides.indexOf(thumb)); return;}
    const nativeStep=event.target.closest('[data-product-thumb-step]');
    if(nativeStep) {
      const strip=nativeStep.closest('.look-gallery__product-thumb-strip');
      const list=strip.querySelector('.product__thumbs');
      const buttons=[...list.querySelectorAll('button')];
      const pages=Math.ceil(buttons.length/3);
      const page=(Number(strip.dataset.thumbPage)+Number(nativeStep.dataset.productThumbStep)+pages)%pages;
      strip.dataset.thumbPage=String(page);
      const target=buttons[page*3];if(target) target.click();
      const item=target?.closest('li');if(item) list.scrollTo({left:item.offsetLeft-list.firstElementChild.offsetLeft,behavior:'smooth'});
      strip.querySelector('.look-gallery__count').textContent=(page*3+1)+' / '+buttons.length;return;
    }
    const thumbStep = event.target.closest('[data-gallery-thumb-step]');
    if (thumbStep) {
      const pages=Math.ceil(slides.length/3);
      const page=(Math.floor(index/3)+Number(thumbStep.dataset.galleryThumbStep)+pages)%pages;
      show(page*3); return;
    }
    const step = event.target.closest('[data-gallery-step]');
    if (step) {show(index + Number(step.dataset.galleryStep)); return;}
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
  });

  function advanceStage(direction) {
    if(!fallback.hidden) show(index+direction);
    else {
      const buttons=[...productBody.querySelectorAll('.product__thumbs button')];
      const active=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-current')==='true'||button.getAttribute('aria-selected')==='true'));
      if(buttons.length) buttons[(active+direction+buttons.length)%buttons.length].click();
    }
  }
  let gesture = null, suppressClickUntil = 0;
  const swipeRows = '[data-gallery-thumbs],[data-related-grid],.product__thumbs';
  const swipeStages = '.look-gallery__image,.product__stage';
  dialog.addEventListener('dragstart', event => {
    if (event.target.closest(swipeRows+','+swipeStages)) event.preventDefault();
  });
  dialog.addEventListener('pointerdown', event => {
    if (event.button && event.pointerType === 'mouse') return;
    const row=event.target.closest(swipeRows);
    const stage=event.target.closest(swipeStages);
    if (!row && !stage) return;
    if (row && event.pointerType !== 'mouse') return;
    gesture={pointer:event.pointerId,x:event.clientX,y:event.clientY,row,stage,start:row?.scrollLeft || 0,dragged:false};
  });
  dialog.addEventListener('pointermove', event => {
    if (!gesture || gesture.pointer!==event.pointerId || !gesture.row) return;
    const dx=event.clientX-gesture.x,dy=event.clientY-gesture.y;
    if (!gesture.dragged && Math.abs(dx)>7 && Math.abs(dx)>Math.abs(dy)) {
      gesture.dragged=true;gesture.row.setPointerCapture(event.pointerId);
      gesture.row.style.scrollSnapType='none';gesture.row.dataset.dragging='true';
    }
    if (gesture.dragged) {event.preventDefault();gesture.row.scrollLeft=gesture.start-dx;}
  });
  function endGesture(event) {
    if (!gesture || gesture.pointer!==event.pointerId) return;
    const g=gesture;gesture=null;
    if(g.row) {
      g.row.style.removeProperty('scroll-snap-type');delete g.row.dataset.dragging;
      if(g.dragged) suppressClickUntil=Date.now()+350;
      return;
    }
    const dx=event.clientX-g.x,dy=event.clientY-g.y;
    if(event.type!=='pointercancel' && Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.3) {
      suppressClickUntil=Date.now()+350;
      const direction=dx<0?1:-1;
      advanceStage(direction);
    }
  }
  dialog.addEventListener('pointerup',endGesture);
  dialog.addEventListener('pointercancel',endGesture);
  dialog.addEventListener('click', event => {
    if(Date.now()<suppressClickUntil && event.isTrusted && event.target.closest(swipeRows+','+swipeStages)) {event.preventDefault();event.stopImmediatePropagation();}
    else {
      const stage=event.target.closest(swipeStages);
      if(stage && !event.target.closest('video,input,select,textarea')) {
        const rect=stage.getBoundingClientRect();
        const direction=(event.clientX-rect.left)<rect.width/3?-1:1;
        event.preventDefault();event.stopImmediatePropagation();advanceStage(direction);
      }
    }
  },true);

  dialog.addEventListener('keydown', event => {
    if (event.target.closest('[data-related-grid]') && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();relatedGrid.scrollBy({left:(event.key==='ArrowRight'?1:-1)*(relatedGrid.clientWidth/3),behavior:'smooth'});return;
    }
    if (!event.target.closest('input,textarea,select,[contenteditable]') && !fallback.hidden) {
      if (event.key === 'ArrowLeft') {event.preventDefault(); show(index - 1);}
      if (event.key === 'ArrowRight') {event.preventDefault(); show(index + 1);}
    }
    if (event.key === 'Escape') event.stopPropagation();
  });
  dialog.addEventListener('dst:look-product-added', () => {
    feedback.hidden = false;
    dialog.querySelector('[data-gallery-feedback-text]').textContent = dialog.dataset.addedLabel;
    feedback.scrollIntoView({block:'nearest',behavior:'smooth'});
  });
  dialog.addEventListener('close', () => {
    request++; if (controller) controller.abort();
    dispose(); stage.removeAttribute('src');
    if (window.DST?.lockScroll) DST.lockScroll(false);
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
})();
